import React, { useState } from 'react';
import styled from 'styled-components';
import { FormattedMessage, useIntl } from 'react-intl';
import { useForm } from 'react-hook-form';

// components

import { Modal } from 'app-components';
import GIButton from '../../../components/common/button/GIButton';

// network

import { api } from '../../../modules/common-utils-services/axiosUtil';
import InputError from '../inputError/InputError';

// styles
const StyledBtn = styled.div`
    display: flex;
    justify-content: space-between;
`;

const StyledCenter = styled.div`
    display: flex;
    justify-content: center;
`;

// props

interface AccountActivationEmailModalProps {
    hhId: string;
    hhEmail: string;
    hhPhone: string;
    onClose: () => void;
}

function AccountActivationEmailModal({ hhId, hhEmail, hhPhone, onClose }: AccountActivationEmailModalProps) {


    const [hhEmaillocal,] = useState<string>('')
    const [hhPhonelocal,] = useState<string>('')

    const householdEmail = sessionStorage.getItem('householdEmail')
    const householdPhone = sessionStorage.getItem('householdPhone')

    const intl = useIntl();

    const { register, handleSubmit, formState: { errors }, setError, clearErrors} = useForm({
        defaultValues: {
            hhEmaillocal,
            hhPhonelocal,
        }
    });

    const onClickSendHandler = async (data) => {
        const url = '/hix/cap/consumer/sendActivationLink';
        let formData = new FormData();
        formData.append('householdId', hhId);
        formData.append('email', data?.hhEmaillocal || hhEmail);
        formData.append('phone', data?.hhPhonelocal || hhPhone);
        const res = await api.post(url, formData);
        if (res && !res.data.success) {
            const emailFormError = { type: "emailExists", message: intl.formatMessage({ id:'common.email.duplicate.error'}) };
            setError('hhEmaillocal', emailFormError);
        }
        else {
            onClose();
            clearErrors();
        }
    };

    const validateEmail=(optionValues)=>{
        const emailRegExp = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
        if(optionValues && emailRegExp.test(optionValues)){
            return true
        } 
        return false;
    }
    const validatePhoneNumber=(optionValues)=>{
        const phoneRegExp = new RegExp(/[0-9]{3}-[0-9]{3}-[0-9]{4}$/);
         if(optionValues && phoneRegExp.test(optionValues)){
            return true
        }
        return false;
    }
    return (
        <form onSubmit={handleSubmit(onClickSendHandler)}>
            <Modal id='account_activation_email_modal'>
                <Modal.Header id='account_activation_email_modal_title' titleId='common.send_activiation_link' onHide={onClose} />
                <Modal.Body>
                    <StyledCenter>
                        <FormattedMessage id='common.send.activation.email' />
                    </StyledCenter>
                    {!householdEmail &&
                        <div className='control-group-input-label-center control-group-input-label-align-center'>
                            <div className="grid-row gi-component gi-regular_input">
                                <label className='tablet:grid-col-12 control-label required-true'>
                                    <FormattedMessage id='common.email.address' />
                                </label>                                
                            </div>
                            <div className='tablet:grid-col-6 controls'>
                                    <input 
                                        type='text' 
                                        id='email' 
                                        className='input-xlarge' 
                                        size={30} 
                                        {...register('hhEmaillocal', { required: {
                                            value: true,
                                            message: intl.formatMessage({ id:'common.email.address.error'})
                                        }, 
                                        validate: {
                                            validate: (optionValues) => validateEmail(optionValues)  || intl.formatMessage({ id:'common.email.address.error'})
                                        }
                                    
                                        })}
                                    />
                                    <InputError id="emailExistMessageId" errorMessage={errors?.hhEmaillocal?.message} isShown={errors?.hhEmaillocal}/>
                                </div>
                        </div>
                    }
                    {!householdPhone &&
                        <div className='control-group-input-label-center control-group-input-label-align-center'>
                            <div className="grid-row gi-component gi-regular_input">
                                <label className='tablet:grid-col-12 control-label required-true'>
                                    <FormattedMessage id='common.phone.number' />
                                </label>
                            </div>
                            <div className='tablet:grid-col-6 controls'>
                                    <input 
                                        type={'text'} 
                                        size={30} 
                                        max={10} 
                                        min={10} 
                                         className='input-xlarge' 
                                        {...register('hhPhonelocal', { required: {
                                            value: true,
                                            message: intl.formatMessage({ id:'common.phone.number.error'})
                                        },
                                        validate: {
                                            validate: (optionValues) => validatePhoneNumber(optionValues) || intl.formatMessage({ id:'common.phone.number.error'})

                                        }
                                        })}
                                    />
                                        <InputError id="phoneNumberMessageId" errorMessage={errors?.hhPhonelocal?.message} isShown={errors?.hhPhonelocal}/>
                                    <div id='email_error'></div>
                                </div>
                        </div>
                    }
                </Modal.Body>
                <Modal.Controls>
                    <StyledBtn>
                        <GIButton id='cancel' labelId='common.cancel' variant='secondary' onClickHandler={onClose}></GIButton>
                        <GIButton type={'submit'} id='member_view' labelId='common.send' variant='primary'></GIButton>
                    </StyledBtn>
                </Modal.Controls>
            </Modal>

        </form>
    )
}

export default AccountActivationEmailModal;